import { nanoid } from "nanoid";

import { idb } from "../../idb.js";
import { enqueue } from "../log-queue/enqueue.js";

export const logToIDB = (level, args) => {
  const entry = {
    id: nanoid(),
    level,
    args,
    timestamp: new Date().toISOString(),
  };

  idb()
    .then((connection) => connection.add("logs", entry))
    .catch(() => enqueue(entry));
};
